import { useState } from 'react'

import { Box, Tabs } from '@fairfashion/design-system'

import { IAResultTab } from './components/IAResultTab/ia-result-tab.comp'
import { PendingItemsTab } from './components/PendingItemsTab/pending-items-tab.comp'
import { ProviderItemsProvider } from './provider-items.context'
import * as Styles from './provider-items.styles'

const TABS = ['Itens pendentes', 'Resultados por IA']

const ProviderItemsComp = () => {
  const [activeTab, setActiveTab] = useState<string>(TABS[0])

  return (
    <Box width="100%" height="100%" direction="column" padding={3}>
      <Tabs tabs={TABS} active={activeTab} onChangeTab={setActiveTab} />

      <Box marginTop={3} marginBottom={1}>
        <Styles.Title as="h1">
          {activeTab === 'Itens pendentes'
            ? 'Itens pendentes'
            : 'Resultados por IA'}
        </Styles.Title>
      </Box>

      <Box width="100%" marginTop={1}>
        {activeTab === 'Itens pendentes' && <PendingItemsTab />}
        {activeTab === 'Resultados por IA' && <IAResultTab />}
      </Box>
    </Box>
  )
}

export const ProviderItems = () => {
  return (
    <ProviderItemsProvider>
      <ProviderItemsComp />
    </ProviderItemsProvider>
  )
}
